import TransactionDetailsFtth from "../../../entities/checkout/transaction/TransactionDetailsFtth";
import { ITransactionDetailsFtth } from "../../../entities/checkout/transaction/types";
import { IManhattanFactory } from "../../manhattan/types";
import { TransactionDetailsInstallerPositionFactory } from "./TransactionDetailsInstallerPositionFactory";
import { TransactionDetailsOrderFactory } from "./TransactionDetailsOrderFactory";

export const TransactionDetailsFtthFactory: IManhattanFactory = class TransactionDetailsFactory {

  static create(transactionDetails: ITransactionDetailsFtth) {
    return new TransactionDetailsFtth(
      TransactionDetailsOrderFactory.create(transactionDetails.order),
      transactionDetails.customer,
      transactionDetails.addresses,
      transactionDetails.transaction,
      transactionDetails.installationDate,
      transactionDetails.installerPosition && TransactionDetailsInstallerPositionFactory.create(transactionDetails.installerPosition),
    );
  }

};
